// removed by extract-text-webpack-plugin
module.exports = {"menuBg":"#f8f8f8","subMenuBg":"#e5e5e5","menuHover":"#d6d6d6","menuText":"#333","menuActiveText":"#1E3A8A","buttonHover":"#274bb2"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/variables.scss
// module id = syC2
// module chunks = 13